import React from "react"
import { useLang } from "~/hooks/useLang"
import useDispatchState from "../../stores/DispatchState";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '~/components/ErrorFallback';
import { Box, Grid, Paper, Typography } from "@mui/material";
import { Validation as validation } from '@hookstate/validation';
import EventInputContainerDispatch from "../EventInputContainerDispatch";
import DispatchTagList from "../DispatchTagList";
import { DispatchDisplayComments } from "../DispatchDisplayComments";
import useUserState from "~/features/User/stores/UserState";
import { useHookstate } from "@hookstate/core";
import EventInputRequesterDispatch from "../EventInputRequesterDispatch";
import ButtonActionsVerticalContainer from "~/components/ButtonActionsVerticalContainer";
import ButtonActionsContainer from "~/components/ButtonActionsContainer";


// eslint-disable-next-line max-lines-per-function
export default function DispatchViewMode() {
  const { translate } = useLang();
  const dispatchState = useDispatchState();
  const { id, type, subtype, occurrence, status, totalSubtypes, totalDistricts, code } = dispatchState.dispatchHistoric();
  const isValid = validation(id).valid();
  const { commentIsCompressed } = useUserState()
  const commentIsCompressedState = useHookstate<boolean>(commentIsCompressed);
  const moveScrolltoComment = useHookstate(false);
  const printDispatch = (id) => {
    window.open(`/dispatch/print/${id}`)
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Grid container>
        <Grid item md={12}
          width={'100%'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <Grid container sx={{ margin: 0 }}>
            {
              !isValid ?
                <Grid item md={11}>
                  <Paper
                    variant='outlined'
                    sx={{
                      height: '535.50px',
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'center'
                    }} >
                    <Box style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography>
                        {translate('No Dispatches')}
                      </Typography>
                    </Box>
                  </Paper>
                </Grid> :
                <>
                  <Grid
                    item md={3.5}
                    width={'100%'}
                    display={'flex'}
                    direction={'column'}
                    alignItems={'center'}
                    gap={1}
                  >
                    <EventInputContainerDispatch
                      readonly={true}
                      isValid={isValid}
                      isValidEdit={status.value?.id !== 8 && status.value?.id !== 10}
                      isInvalidRequest={false}
                      subTypeName={subtype?.name}
                      typeName={type?.name}
                      id={id}
                      lat={occurrence.latitude}
                      lon={occurrence.longitude}
                      typeId={type?.id}
                      typeCode={type?.code}
                      subtypeId={subtype?.id}
                      subtypeCode={subtype?.code}
                      city={occurrence?.city}
                      district={occurrence?.district}
                      cityId={occurrence?.city?.id}
                      districtId={occurrence?.district?.id}
                      type={'dispatch'}
                      location={occurrence?.location}
                      reference={occurrence?.reference}
                      totalSubtypes={totalSubtypes}
                      totalDistricts={totalDistricts}
                      dispatchViewMode={true}
                    />
                    <DispatchTagList dispatchViewMode={true} />
                  </Grid>

                  <Grid item md={4} width={'100%'} display={'flex'} direction={'column'} alignItems={'center'} justifyContent={'space-between'} paddingLeft={1}>
                    <Grid
                      container
                      sx={{ height: '100%', width: '100%', margin: 0 }}
                      direction={'column'}
                      justifyContent={'space-between'}
                    >
                      <Grid item md xs sx={{ overflowY: 'auto', width: '100%', height: '100%' }}
                      >
                        <DispatchDisplayComments
                          dispatchId={id.get()}
                          readonly={true}
                          commentIsCompressed={commentIsCompressedState}
                          moveScrolltoComment={moveScrolltoComment.get()}
                          ocurrenceId={occurrence.id.get()}
                          code={String(code.get())}
                          dispatchViewMode={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <EventInputRequesterDispatch
                    dispatchId={id.get()}
                    readonly={true}
                    isValid={isValid}
                    isValidEdit={status.value?.id !== 8 && status.value?.id !== 10}
                    dispatchViewMode={true}
                  />
                </>
            }

            <Grid
              item
              md={1}
              width={'100%'}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <ButtonActionsVerticalContainer
                readonly={true}
                isValid={isValid}
                canAddReportingRecord={false}
                canChronology={isValid && true}
                chronology={occurrence.get()?.id}
                dispatchId={id?.get()}
                statusId={status.value?.id ?? undefined}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item columnSpacing={1} md={12} sx={{ mt: '10px' }}>
          <ButtonActionsContainer
            isValid={isValid}
            id={id.get() as number}
            canPrint={isValid && true && status.value?.id === 8}
            print={() => printDispatch(id.get())}
          />
        </Grid>
      </Grid>
    </ErrorBoundary>
  )
}